import React, { useEffect, useState } from 'react';
import { SpeakComappModelItem } from '../models/superbit-api-models';
import ClientCallItem from './_ClientCallItem';
import './calls.css';

type Props = {
    data: any[];
    config?: any;
    actions?: Function[]
};

const CallsTable =(props: Props)=> {
    const [callItemsList, setCallItemsList] = useState<SpeakComappModelItem[]>([]);

    useEffect(()=>{
        const data = props.data ? props.data : [];
        setCallItemsList(data);
        console.log('data changed', props.data)
    },[props.data]);
    
    return (
        <>
            <div className='content-table calls-content-table'>
                <div className='content-header content-table-header client-leads-list-header'>
                    <div className="content-table-header flex-space-between flex-centered">
                        <div className='cell date'>
                        תאריך 
                        </div>
                        <div className='cell source'>
                        מקור
                        </div>
                        <div className='cell target'>
                        יעד
                        </div>
                        <div className='cell call-length'>
                        אורך שיחה
                        </div>
                        <div className='cell link'>
                        לינק 
                        </div>
                    </div>
                </div>
                <div className='content-table-body'>
                {callItemsList ? (<>
                    {callItemsList.map((callItem: SpeakComappModelItem, index: number)=> {
                        return (
                            <>
                        <ClientCallItem callItemDetails={callItem} config={{}} key={index} />
                            </>
                        )
                    })}
                </>) : (<></>)}
                </div>
        </div>
        </>
    )
}




export default CallsTable;